import type { WhatsNewBody } from '../types';

export default {
  title: 'RFIs and submittals go to the job’s contacts',
  summary:
    'An RFI’s Assigned to and a submittal’s Reviewer can now be picked from the job’s Contacts tab. The Outlook draft starts addressed to them, and when you mark it sent, the Project Tracker records who it went to.',
  details: [
    'Add anyone else on CC, from the job’s contacts or by typing an address.',
    'A reminder or a revision starts addressed to whoever the last send went to.',
    'The role labels are still there for a job with no contacts yet.',
  ],
  audience: { label: 'project managers and engineers', test: (a) => a.editsProjects },
  tryIt: { to: '/projects', label: 'Open Projects' },
  guide: { topic: 'pm-rfis' },
} satisfies WhatsNewBody;
